import {
  InvoiceTypeEnum,
  InvoiceTypeObj,
  PurchaseInvoiceStatusEnum,
  PurchaseInvoiceStatusObj,
  FiltrYearTypeEnum,
  FiltrYearTypeObj,
} from '../../../../common/pokCore/validation/enums';

export const getDateValue = (
  dateRange: [Date | null, Date | null] | null | undefined,
  index: 0 | 1,
): Date | undefined => dateRange?.[index] ?? undefined;

export const createSelectOptions = (t: (key: string) => string) => ({
  typeOptions: Object.entries(InvoiceTypeEnum).map(([key, value]) => ({
    value: key as InvoiceTypeEnum,
    label: t(InvoiceTypeObj[value]),
  })),

  statusOptions: Object.entries(PurchaseInvoiceStatusEnum).map(
    ([key, value]) => ({
      value: key as PurchaseInvoiceStatusEnum,
      label: t(PurchaseInvoiceStatusObj[value]),
    }),
  ),

  yearTypeOptions: Object.entries(FiltrYearTypeEnum).map(([key, value]) => ({
    value: key as FiltrYearTypeEnum,
    label: t(FiltrYearTypeObj[value]),
  })),
});
